import { BowtieSubordinateCases, BowtieConnectedCases, BowtieAnchorRoot } from '../types';

function flattenSuboridnateCases(subordinateCases: BowtieSubordinateCases[]): number[] {
  return subordinateCases && subordinateCases.length
    ? subordinateCases.reduce((result, subordinateCase) => [
      ...result,
      subordinateCase.caseId,
      ...flattenConnectedCases(subordinateCase.connected)
    ], [])
    : [];
}

function flattenConnectedCases(connectedCases: BowtieConnectedCases[]): number[] {
  return connectedCases && connectedCases.length
    ? connectedCases.reduce((result, connecteCase) => [
      ...result,
      ...flattenSuboridnateCases(connecteCase.subordinateCases)
    ], [])
    : [];
}

export const flattenAnchorRoots = (roots: BowtieAnchorRoot[]): number[] =>
  roots && roots.length
    ? roots.reduce((result, root) => [
      ...result,
      root.caseId,
      ...flattenConnectedCases(root.connectedCases)
    ], [])
    : [];
